export const customerConfigKey = 'customerConfig';
